import { useTranslation } from 'contexts/Localization'
import React from 'react'
import styled, { useTheme as useStyledTheme } from 'styled-components'
import { Flex, Text, ArrowForwardIcon, Rocket2, Skeleton, InfoIcon, useTooltip } from 'vvs-uikit'
import useBoostFactor from 'hooks/boost-farm/useBoostFactor'
import { DeserializedFarm } from 'state/types'
import { TokenPairText, TokenWrapper } from 'views/BoostCalculator/styles'
import { TokenPairImage } from 'components/TokenImage'
import { getDisplayApr, getBoostedDisplayApr } from 'views/Farms/utils'
import MultiplierContent from './MultiplierContent'

const Wrapper = styled.div``

const Title = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-indent: 8px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  margin-bottom: 16px;
`

const MultiplierList = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const ApplyText = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`

export const BoostMultiplierRow: React.FC<{
  farm: DeserializedFarm
  vvsRewardsApr?: number
  tokenRewardsApr?: number
  lpRewardsApr?: number
  showApplyToBtn?: boolean
  boostingNfts?: []
}> = ({ farm, vvsRewardsApr, tokenRewardsApr, lpRewardsApr, showApplyToBtn = true, boostingNfts = [] }) => {
  const { colors } = useStyledTheme()
  const { t } = useTranslation()
  const { data: xVVSBoostFactorData, isLoading } = useBoostFactor({ farmId: farm.pid, nfts: boostingNfts }, true)

  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    t(
      'Your APR% remain the same because you do not have any staked liquidity in the selected farm.  You can continue applying the boost and stake liquidity in this farm later to enjoy the boost APR%',
    ),
    { placement: 'top-end', tooltipOffset: [20, 10] },
  )

  const boostedApr = getBoostedDisplayApr(
    vvsRewardsApr,
    tokenRewardsApr,
    lpRewardsApr,
    xVVSBoostFactorData?.boostFactor,
    1,
    1,
  )

  return (
    <Flex flexDirection="column">
      <Flex justifyContent="space-between" flexDirection="row" gap="10px">
        <Flex alignItems="center" justifyContent="center">
          <TokenWrapper>
            <TokenPairImage
              primaryToken={farm.token}
              secondaryToken={farm.quoteToken}
              variant="inverted"
              width={40}
              height={40}
            />
          </TokenWrapper>
          <TokenPairText>{farm.lpSymbol.split(' ')[0]}</TokenPairText>
        </Flex>
        <Flex alignItems="center" gap="5px" justifyContent="center">
          <Rocket2 width={16} height={16} color={colors.text} />

          <Text fontSize="16px" fontWeight="600" lineHeight="24px">
            {`${getDisplayApr(tokenRewardsApr, lpRewardsApr, 1)}%`}
          </Text>
          <ArrowForwardIcon width="24px" height="24px" color={colors.text} />
          {isLoading || Number.isNaN(boostedApr) ? (
            <Skeleton width="40px" height="24px" />
          ) : (
            <Text fontSize="16px" fontWeight="600" lineHeight="24px">
              {`${boostedApr}%`}
            </Text>
          )}
          {!isLoading && xVVSBoostFactorData?.boostFactor === 1 && (
            <Flex ref={targetRef}>
              <InfoIcon color="primary" />
              {tooltipVisible && tooltip}
            </Flex>
          )}
        </Flex>
      </Flex>
      {showApplyToBtn && (
        <Flex justifyContent="flex-end" alignItems="center">
          <ApplyText>{t('Apply to another farm')}</ApplyText>
        </Flex>
      )}
    </Flex>
  )
}

const BoostFarmDetails = () => {
  // TODO: get data from ABI
  const { t } = useTranslation()
  const { colors } = useStyledTheme()

  return (
    <Wrapper>
      <Title>
        <Rocket2 width={16} height={16} color={colors.text} />
        {t('Boosted LP Farm')}
      </Title>
      <MultiplierContent xVVSBoostFactor={1.6} nftBoostFactor={0} />
      <MultiplierList>
        {/* <BoostMultiplierRow /> */}
        {/* <BoostMultiplierRow /> */}
      </MultiplierList>
    </Wrapper>
  )
}

export default BoostFarmDetails
